import script from "./quick-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./quick-search.vue?vue&type=script&setup=true&lang=ts"

import "./quick-search.vue?vue&type=style&index=0&id=42c1c737&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c1c737"]])

export default __exports__